import React, { useState, useEffect, Children } from "react";
import { EmployeeTeamVM } from "../../Models/ViewModels";
import {
  Table,
  Pagination,
  Stack,
  Avatar,
  Input,
  Button,
  Toggle,
} from "rsuite";
import * as TeamDB from "../../Services/EmployeeDB";
import { PageHeader } from "../../SharedComponents/PageHeader";
import * as XLSX from "xlsx";
import { TeamCard } from "./TeamCard";
import { TeamDetailSimple } from "./TeamDetailSimple";
import { handleDownloadAsExcel } from "../../Helpers/Utils";
import { GetUserLoginID } from "../../Services/UserSessionManager";
import { CustomTableHeaderCell } from "../../SharedComponents/CustomTableHeaderCell";
import { CustomTableCell } from "../../SharedComponents/CustomTableCell";
import { Modal } from "react-bootstrap";
import { TeamMembers } from "./TeamMembers";
import { BootstrapIcon } from "../../SharedComponents/BootstrapIcon";
import { ProcessTeamMembers } from "./ProcessTeamMembers";
const { Column, HeaderCell, Cell, ColumnGroup } = Table;
const colors = ["pink", "grey", "blue", "yellow", "purple", "green", "red"];

export const ManagerProcess = ({ name, designation, department }: any) => {
  const proc: any = [];
  const proc1: any = [];
  const [cachedTeamList, setCachedTeamList] = useState(
    new Array<EmployeeTeamVM>()
  );
  const [processName, setProcessName] = useState(new Array<EmployeeTeamVM>());
  const [sortColumn, setSortColumn] = useState();
  const [sortType, setSortType] = useState();
  const [isLoading, setLoading] = useState(true);
  const [page, setPage] = React.useState(1);
  const [limit, setLimit] = React.useState(15);
  const [filteredTeamList, setFilteredTeamList] = useState(
    new Array<EmployeeTeamVM>()
  );
  const [checked, setChecked] = useState(false);
  const [loginid, setLoginid] = useState(GetUserLoginID());
  const [popup, setPopUp] = useState(false);
  const [teamMembers, setTeamMembers] = useState([]);
  const [searching, setSearching] = useState(false);
  useEffect(() => {
    getAllManagerList(loginid);
  }, []);

  const handleClose = () => setPopUp(false);
  const filterData = (val: string, e: any) => {
    let searchText = val;
    setPage(1);
    if (searchText) {
      setFilteredTeamList(
        cachedTeamList.filter((e) =>
          JSON.stringify(e).toLowerCase().includes(searchText.toLowerCase())
        )
      );
      setSearching(true);
    } else {
      setFilteredTeamList([...cachedTeamList]);
      setSearching(false);
    }
  };

  const tableDataFeed = filteredTeamList.filter((v, i) => {
    const start = limit * (page - 1);
    const end = start + limit;
    return i >= start && i < end;
  });

  const handleChangeLimit = (dataKey: any) => {
    setPage(1);
    setLimit(dataKey);
  };

  const getFTEBuff = (processesArray: any[], processName: string) => {
    for (let i = 0; i < processesArray.length; i++) {
      if (processesArray[i].ProcessName === processName) {
        return processesArray[i].FTEBuff;
      }
    }
    return "";
  };

  const getAllManagerList = (loginid: any) => {
    TeamDB.GetManagerDetails(loginid)
      .then((res: EmployeeTeamVM[] | any) => {
        if (res) {
          res = res.data;
          for (let i = 0; i < res.length; i++) {
            res[i].ALLFTEBuffer = +getFTEBuff(res[i].Processes, "ALL");

            res[i].ARFTEBuffer = +getFTEBuff(res[i].Processes, "AR");

            res[i].CodingFTEBuffer = +getFTEBuff(res[i].Processes, "Coding");

            res[i].CPFTEBuffer = +getFTEBuff(res[i].Processes, "CP");

            res[i].DemoFTEBuffer = +getFTEBuff(res[i].Processes, "Demo");

            res[i].DenialsFTEBuffer = +getFTEBuff(res[i].Processes, "Denials");

            res[i].CredentialingFTEBuffer = +getFTEBuff(
              res[i].Processes,
              "Credentialing"
            );

            res[i].NAFTEBuffer = +getFTEBuff(res[i].Processes, "NA");

            res[i].OtherFTEBuffer = +getFTEBuff(res[i].Processes, "Other");

            res[i].PFSFTEBuffer = +getFTEBuff(res[i].Processes, "PFS");

            res[i].PPFTEBuffer = +getFTEBuff(res[i].Processes, "PP");

            res[i].StatementsFTEBuffer = +getFTEBuff(
              res[i].Processes,
              "Statements"
            );

            res[i].Total =
              res[i].ALLFTEBuffer +
              res[i].ARFTEBuffer +
              res[i].CodingFTEBuffer +
              res[i].CPFTEBuffer +
              res[i].DemoFTEBuffer +
              res[i].DenialsFTEBuffer +
              res[i].CredentialingFTEBuffer +
              res[i].NAFTEBuffer +
              res[i].OtherFTEBuffer +
              res[i].PFSFTEBuffer +
              res[i].PPFTEBuffer +
              res[i].StatementsFTEBuffer;
          }

          setCachedTeamList(res);
          setFilteredTeamList(res);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleSortColumn = (sortColumn: any, sortType: any) => {
    setTimeout(() => {
      setSortColumn(sortColumn);
      setSortType(sortType);
    }, 500);
    if (sortColumn && sortType) {
      return cachedTeamList.sort((a: any, b: any) => {
        let x = a[sortColumn];
        let y = b[sortColumn];
        if (typeof x === "string" || "") {
          x = x.charCodeAt();
        }
        if (typeof y === "string" || "") {
          y = y.charCodeAt();
        }
        if (sortType === "asc") {
          return x - y;
        } else {
          return y - x;
        }
      });
    }
  };

  const handelDetailsPopUp = (rowData: any, loginid: any) => {
    TeamDB.GetManagerMembersDetails(loginid, rowData.Manager).then((res) => {
      setTeamMembers(res.data);
      setPopUp(true);
    });
  };

  return (
    <>
      <div className="row">
        <div className="col-md-8">
          <PageHeader title="Manager Process Buffer Details (FTE)" backPage="">
            <></>
          </PageHeader>
        </div>
        {
          <div className="col-md-3">
            <Input
              className="form-control w-100 "
              type="search"
              autoFocus={true}
              placeholder={"Search by Name...."}
              onChange={filterData}
            />
          </div>
        }
        {!checked ? (
          <div className="col-md-1">
            {searching == true ? (
              <button
                id="color"
                onClick={() => handleDownloadAsExcel(tableDataFeed)}
              >
                <BootstrapIcon
                  bootStrapIconName={"file-earmark-arrow-down-fill"}
                  size={30}
                  cssClasses={"pe-2"}
                />{" "}
              </button>
            ) : (
              <button
                id="color"
                onClick={() => handleDownloadAsExcel(cachedTeamList)}
              >
                <BootstrapIcon
                  bootStrapIconName={"file-earmark-arrow-down-fill"}
                  size={30}
                  cssClasses={"pe-2"}
                />{" "}
              </button>
            )}
          </div>
        ) : (
          <div className="col-md-2"></div>
        )}

        <hr />
      </div>

      <div>
        <Modal show={popup} onHide={handleClose} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Team Members</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ProcessTeamMembers members={teamMembers} />
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-danger" onClick={handleClose}>
              Close
            </button>
            <button
              className="btn btn-primary"
              onClick={() => handleDownloadAsExcel(teamMembers)}
            >
              Export To Excel
            </button>
          </Modal.Footer>
        </Modal>

        <div className="show-container">
          <Table
            id="table"
            height={390}
            data={tableDataFeed}
            sortColumn={sortColumn}
            sortType={sortType}
            onSortColumn={handleSortColumn}
            loading={isLoading}
            bordered={true}
            cellBordered={true}
            className="border border-dark mt-2"
            rowHeight={30}
            headerHeight={30}
            onRowClick={(rowData: any) => {
              handelDetailsPopUp(rowData, loginid);
            }}
          >
            <Column flexGrow={270} align="left" resizable sortable>
              <CustomTableHeaderCell placement={"Manager"}>
                Manager
              </CustomTableHeaderCell>

              <CustomTableCell>
                {(rowData: any) => {
                  return <p>{rowData.Manager}</p>;
                }}
              </CustomTableCell>
            </Column>
            <Column flexGrow={70} resizable>
              <CustomTableHeaderCell placement={"ALL"}>
                ALL
              </CustomTableHeaderCell>
              <CustomTableCell>
                {(rowData: EmployeeTeamVM) => {
                  return (
                    <div className="col-md-0 ">{rowData.ALLFTEBuffer}</div>
                  );
                }}
              </CustomTableCell>
            </Column>
            <Column flexGrow={70} resizable>
              <CustomTableHeaderCell placement={"AR"}>AR</CustomTableHeaderCell>
              <CustomTableCell>
                {(rowData: EmployeeTeamVM) => {
                  return <div className="col-md-0 ">{rowData.ARFTEBuffer}</div>;
                }}
              </CustomTableCell>
            </Column>
            <Column flexGrow={90} resizable>
              <CustomTableHeaderCell placement={"Coding"}>
                Coding
              </CustomTableHeaderCell>
              <CustomTableCell>
                {(rowData: EmployeeTeamVM) => {
                  return (
                    <div className="col-md-0 ">{rowData.CodingFTEBuffer}</div>
                  );
                }}
              </CustomTableCell>
            </Column>
            <Column flexGrow={80} resizable>
              <CustomTableHeaderCell placement={"CP"}>CP</CustomTableHeaderCell>
              <CustomTableCell>
                {(rowData: EmployeeTeamVM) => {
                  return <div className="col-md-0 ">{rowData.CPFTEBuffer}</div>;
                }}
              </CustomTableCell>
            </Column>

            <Column flexGrow={105} resizable>
              <CustomTableHeaderCell placement={"Credentialing"}>
                Credentialing
              </CustomTableHeaderCell>
              <CustomTableCell>
                {(rowData: EmployeeTeamVM) => {
                  return (
                    <div className="col-md-0 ">
                      {rowData.CredentialingFTEBuffer}
                    </div>
                  );
                }}
              </CustomTableCell>
            </Column>

            <Column flexGrow={70} resizable>
              <CustomTableHeaderCell placement={"Demo"}>
                Demo
              </CustomTableHeaderCell>
              <CustomTableCell>
                {(rowData: EmployeeTeamVM) => {
                  return (
                    <div className="col-md-0 ">{rowData.DemoFTEBuffer}</div>
                  );
                }}
              </CustomTableCell>
            </Column>
            <Column flexGrow={80} resizable>
              <CustomTableHeaderCell placement={"Denials"}>
                Denials
              </CustomTableHeaderCell>
              <CustomTableCell>
                {(rowData: EmployeeTeamVM) => {
                  return (
                    <div className="col-md-0 ">{rowData.DenialsFTEBuffer}</div>
                  );
                }}
              </CustomTableCell>
            </Column>

            <Column flexGrow={70} resizable>
              <CustomTableHeaderCell placement={"PFS"}>
                PFS
              </CustomTableHeaderCell>
              <CustomTableCell>
                {(rowData: EmployeeTeamVM) => {
                  return (
                    <div className="col-md-0 ">{rowData.PFSFTEBuffer}</div>
                  );
                }}
              </CustomTableCell>
            </Column>

            <Column flexGrow={60} resizable>
              <CustomTableHeaderCell placement={"PP"}>PP</CustomTableHeaderCell>
              <CustomTableCell o>
                {(rowData: EmployeeTeamVM) => {
                  return <div className="col-md-0 ">{rowData.PPFTEBuffer}</div>;
                }}
              </CustomTableCell>
            </Column>

            <Column flexGrow={110} resizable>
              <CustomTableHeaderCell placement={"Statements"}>
                Statements
              </CustomTableHeaderCell>
              <CustomTableCell>
                {(rowData: EmployeeTeamVM) => {
                  return (
                    <div className="col-md-0 ">
                      {rowData.StatementsFTEBuffer}
                    </div>
                  );
                }}
              </CustomTableCell>
            </Column>
            <Column flexGrow={80} resizable>
              <CustomTableHeaderCell placement={"Other"}>
                Other
              </CustomTableHeaderCell>
              <CustomTableCell>
                {(rowData: EmployeeTeamVM) => {
                  return (
                    <div className="col-md-0 ">{rowData.OtherFTEBuffer}</div>
                  );
                }}
              </CustomTableCell>
            </Column>
            <Column flexGrow={70} resizable>
              <CustomTableHeaderCell placement={"NA"}>NA</CustomTableHeaderCell>
              <CustomTableCell>
                {(rowData: EmployeeTeamVM) => {
                  return <div className="col-md-0 ">{rowData.NAFTEBuffer}</div>;
                }}
              </CustomTableCell>
            </Column>

            <Column flexGrow={80} resizable>
              <CustomTableHeaderCell placement={"Total"}>
                Total
              </CustomTableHeaderCell>
              <CustomTableCell dataKey="Total" />
            </Column>
          </Table>
          {filteredTeamList && (
            <div style={{ padding: 20 }}>
              <Pagination
                prev
                next
                first
                last
                ellipsis
                boundaryLinks
                maxButtons={5}
                size="md"
                layout={["total", "-", "limit", "|", "pager", "skip"]}
                total={filteredTeamList.length}
                limitOptions={[10, 15, 20, 30]}
                limit={limit}
                activePage={page}
                onChangePage={setPage}
                onChangeLimit={handleChangeLimit}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};
